module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7r9r3r-10f1151b4b9540986eae41650b3e66f6.svg";